function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as components from "../muiOverrides/components";
import { shadows } from "../muiOverrides/Shadows";
import { createTheme } from '@mui/material';
import { baseTheme } from "./base";
import { grey } from "@mui/material/colors";
var _createTheme = createTheme(),
  breakpoints = _createTheme.breakpoints,
  spacing = _createTheme.spacing;
export var psPatientsTheme = _objectSpread(_objectSpread({
  name: 'Patients'
}, baseTheme), {}, {
  shadows: shadows,
  components: components,
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 684,
      lg: 1000,
      xl: 1440
    }
  },
  palette: _objectSpread(_objectSpread({}, baseTheme.palette), {}, {
    divider: grey[400],
    background: {
      default: '#FFFFFF'
    },
    primary: {
      main: '#112AA7',
      dark: '#0c1d6e',
      light: '#e8e9f9'
    },
    text: {
      secondary: '#22222299'
    }
  }),
  typography: function typography(palette) {
    return {
      fontFamily: ['Inter', 'Roboto', 'Helvetica', 'Arial'].join(','),
      h1: {
        fontSize: '96px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      h2: {
        fontSize: '60px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      h3: {
        fontSize: '48px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      h4: {
        fontSize: '28px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      h5: {
        fontSize: '24px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      h6: {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '1.63'
      },
      subtitle1: {
        lineHeight: '1.63'
      },
      subtitle2: {
        color: palette.text.secondary,
        lineHeight: '1.63'
      },
      body1: {
        lineHeight: '1.63'
      },
      body2: {
        lineHeight: '1.63'
      },
      caption: {
        fontSize: '12px',
        fontWeight: '500'
      }
    };
  }
});
//# sourceMappingURL=sc-vars-patients.js.map